module.exports = __webpack_public_path__ + "img/cloud08.30cf8c11.png";